import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";

const Codex = () => {
    const { childId } = useParams();
    const navigate = useNavigate();
    
    const [reports, setReports] = React.useState(() =>
    JSON.parse(localStorage.getItem("shadowGroveReports") || "[]")
);


    const gradedQuests = useMemo(() => {
        const savedQuests = JSON.parse(
            localStorage.getItem("shadowGroveQuests") || "[]"
        );

        return savedQuests
            .filter((q) => q.child_id === childId && q.status === "graded")
            .sort((a, b) => new Date(b.graded_at) - new Date(a.graded_at));
    }, [childId]);
        const childReports = reports.filter(
    (r) => r.child_id === childId
);

    return (
        <div className="relative min-h-screen bb-night-bg bb-stars overflow-hidden text-white">
            <header className="relative z-10 border-b border-[var(--bb-border)]">
                <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-3">
                    <button
                        onClick={() => navigate(`/quests/${childId}`)}
                        className="bb-btn-ghost flex items-center gap-2"
                    >
                        <ArrowLeft size={16} /> Quest Desk
                    </button>

                    <div className="text-center">
                        <p className="text-xs uppercase tracking-[0.2em] text-[#6c7a9c]">
                            Archive
                        </p>
                        <h1 className="font-display text-3xl flex items-center gap-2 justify-center">
                            <BookOpen size={24} className="text-[#b388ff]" />
                            The Codex
                        </h1>
                    </div>

                    <div className="w-24" />
                </div>
            </header>

            <main className="relative z-10 max-w-6xl mx-auto px-6 py-10">
                {gradedQuests.length === 0 ? (
                    <div className="bb-card p-6 text-center text-[#b0b8d6]">
                        No graded quests yet.
                    </div>
                ) : (
                    <div className="space-y-8">
    {Object.entries(
        gradedQuests.reduce((acc, q) => {
            if (!acc[q.subject]) {
                acc[q.subject] = [];
            }

            acc[q.subject].push(q);

            return acc;
        }, {})
    ).map(([subject, subjectQuests]) => {
        const average =
            subjectQuests.reduce((sum, q) => sum + (q.grade || 0), 0) /
            subjectQuests.length;

        return (
            <section key={subject} className="space-y-3">
                <div className="flex items-center justify-between">
                    <h2 className="font-display text-2xl text-[#b388ff]">
                        {subject}
                    </h2>

                    <div className="text-sm text-[#ffd166]">
                        Average: {average.toFixed(1)}/4
                    </div>
                </div>

                <div className="space-y-4">
                    {subjectQuests.map((q) => (
                        <div key={q.quest_id} className="bb-card p-4">
                            <p className="text-xs uppercase tracking-widest text-[#6c7a9c]">
                                {q.quest_type}
                            </p>

                            <h2 className="font-display text-xl">
                                {q.name}
                            </h2>

                            <p className="text-sm text-[#b0b8d6] mt-1">
                                Grade: {q.grade}/4 · Points:{" "}
                                {q.awarded_points}
                            </p>

                            {q.graded_at && (
                                <p className="text-xs text-[#ffd166] mt-1">
                                    Completed:{" "}
                                    {new Date(q.graded_at).toLocaleDateString(
                                        "en-US",
                                        {
                                            month: "long",
                                            day: "numeric",
                                            year: "numeric",
                                        }
                                    )}
                                </p>
                            )}

                            {q.parent_message && (
                                <p className="italic text-sm mt-3 text-[#b0b8d6]">
                                    "{q.parent_message}"
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </section>
        );
    })}
</div>
                )}
            </main>
        </div>
    );
};

export default Codex;